export const continent2indexes = 
{
    ABB: ["HSI50","KOSPI","NIFTY50","NIKKEI225","STI"],
    EEE: ["AEX25","BEL20","CAC40","DAX40","EUROSTOXX50","FTSE100","FTSEMIB","IBEX35","ISEQ20","OBXO25","OMXC25","OMXH25","OMXS30","PSI20","SMI"],
    FFF: ["SA40"],
    NNN: ["BMVIPC","DOWJONES","NASDAQ100","SP500","TSX60"],
    SRR: ["CLXIPSA","IBOVESPA","MERVAL"],
    UUU: ["ASX50"]
    }